"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Modal = require("./Modal.Styled");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Modal = _ref => {
  let {
    title,
    close,
    children,
    footerContent,
    closeContent = 'close',
    onEnter,
    preventEnter = false,
    open = false
  } = _ref;
  const escFunction = (0, _react.useCallback)(event => {
    if (event.key === 'Escape') {
      close();
    } else if (event.key === 'Enter' && onEnter) {
      onEnter();
      event.preventDefault();
    } else if (event.key === 'Enter' && preventEnter) {
      event.preventDefault();
    }
  }, [close, onEnter, preventEnter]);

  const matchesConditions = () => children && title && typeof close === 'function' && open === true;

  (0, _react.useEffect)(() => {
    if (matchesConditions()) {
      document.addEventListener('keydown', escFunction);
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = 'unset';
        document.removeEventListener('keydown', escFunction);
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [escFunction]);
  if (!matchesConditions()) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement(_Modal.StyledModal, null, /*#__PURE__*/_react.default.createElement(_Modal.Core, null, /*#__PURE__*/_react.default.createElement(_Modal.Header, null, /*#__PURE__*/_react.default.createElement(_Modal.Title, null, title), /*#__PURE__*/_react.default.createElement(_Modal.Close, {
    onClick: close
  }, closeContent)), /*#__PURE__*/_react.default.createElement(_Modal.Content, null, children), footerContent && /*#__PURE__*/_react.default.createElement(_Modal.Footer, null, footerContent)), /*#__PURE__*/_react.default.createElement(_Modal.Background, {
    onClick: close
  }));
};

var _default = Modal;
exports.default = _default;